export default __webpack_public_path__ + "static/media/385.8d268c70.png";